import { CSSProperties } from 'react';

import lang from '../../../../lib/language';
import { formatCurrency } from '../../../../lib/util/DataHelpers';

export const formatNumber = (priceNumber?: number) => {
  if (!priceNumber) {
    return formatCurrency(0);
  }
  return `-${formatCurrency(Math.abs(priceNumber))}`;
};

export const getLabelTextAndStyle = (number: number, max: number): {
    style: CSSProperties,
    text: string,
} => {
  if (!number || !max || number < max * 0.5) {
    return {
      text: lang.commonGood(),
      style: {
        color: '#1BFEBA',
        backgroundColor: '#1BFEBA1A',
      },
    };
  }
  if (number < max * 0.75) {
    return {
      text: lang.commonWarning(),
      style: {
        color: '#F6C98E',
        backgroundColor: '#F6C98E1A',
      },
    };
  }
  return {
    text: lang.commonCritical(),
    style: {
      color: '#F96C75',
      backgroundColor: '#F96C751A',
    },
  };
};
